import { render, staticRenderFns } from "./STag.vue?vue&type=template&id=3575e786&scoped=true&"
import script from "./STag.vue?vue&type=script&lang=js&"
export * from "./STag.vue?vue&type=script&lang=js&"
import style0 from "./STag.vue?vue&type=style&index=0&id=3575e786&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575e786",
  null
  
)

export default component.exports